// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Nwma","inputWrap":"styles_inputWrap__3B_aM","input":"styles_input__1UKKv"};